import React, { useState } from "react";
import axios from "axios";
import { hostName } from "../../../../App";
import { MDBBtn } from "mdb-react-ui-kit";
import { useNavigate } from "react-router-dom";
import { ClapSpinner } from "react-spinners-kit";
import { useTranslation } from "react-i18next";
import Icon from "react-icons-kit";
import { arrows_left } from "react-icons-kit/linea/arrows_left";
import Tippy from "@tippyjs/react";
import { LazyLoadImage } from "react-lazy-load-image-component";

const OrganizationHeader = ({
  userData,
  setLoggedInUserData,
  orgObj,
  setOrgObj,
  content,
  handleGoBack,
}) => {
  // translation
  const { t } = useTranslation();

  // states
  const [btnLoader, setBtnLoader] = useState(false);

  // navigate
  const navigate = useNavigate();

  // handle follow
  const handleFollow = (organization) => {
    if (!btnLoader) {
      if (!userData) {
        navigate("/signin");
      } else {
        setBtnLoader(true);
        const axiosConfig = {
          headers: {
            Authorization: `Bearer ${userData.token}`,
          },
        };
        axios
          .post(
            `${hostName}api/v1/donor/follow?organizationTag=${organization.tagNumber}`,
            {},
            axiosConfig
          )
          .then((res) => {
            setOrgObj((prevOrg) => ({
              ...prevOrg,
              isFollowing: res.data?.data?.isFollowing, // Ensure safe access
            }));
          })
          .catch((err) => {
            if (err.response.status === 401) {
              localStorage.removeItem("user");
              setLoggedInUserData(null);
              navigate("/signin");
            }
          })
          .finally(() => setBtnLoader(false));
      }
    }
  };

  return (
    <>
      {content && (
        <div style={{ background: "#f8f8f8" }}>
          <Tippy content={content}>
            <button
              type="button"
              style={{
                backgroundColor: "transparent",
                color: "#9b9b9b",
                border: "none",
                outline: "none",
                paddingBottom: "8px",
              }}
              onClick={handleGoBack}
            >
              <Icon icon={arrows_left} size={48} />
            </button>
          </Tippy>
        </div>
      )}

      <header className="card-header">
        <div className="card-leftside single-card">
          <div className="card-logo">
            <LazyLoadImage src={orgObj.logo} alt="card-logo" effect="blur" />
          </div>
          <div className="title-and-city-country">
            <div className="organization-name">
              {orgObj.name}{" "}
              {orgObj.locationName && <>- {orgObj.locationName}</>}
            </div>
            <div className="city-and-country single-card">
              {orgObj.city}, {orgObj.currencyCode}
            </div>
          </div>
        </div>

        <MDBBtn
          className="follow-btn"
          onClick={() => handleFollow(orgObj)}
          disabled={btnLoader}
        >
          {orgObj.isFollowing
            ? t("OrganizationDetails.following")
            : t("OrganizationDetails.follow")}
          {btnLoader && (
            <div className="btn-loader">
              <ClapSpinner size={24} color="#fff" loading={btnLoader} />
            </div>
          )}
        </MDBBtn>
      </header>
    </>
  );
};

export default OrganizationHeader;
